module.exports = __webpack_public_path__ + "img/logo-icdc.4439359.gif";